const Loader = ({ size }) => {
  return <img src="../images/loader.svg" width={size} />;
};
export default Loader;
